import { useState } from "react";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import BasePage from "ui/common/components/layout/BasePage/BasePage";
import YellowTabs from "ui/common/components/navigation/YellowTabs/YellowTabs";
import { MainRoutes } from "ui/common/router/MainRouter.types";
import useScanModalTabs from "ui/transactions/containers/ScanModal/hooks/useScanModalTabs";

export default function SendAndReceivePage() {
    const tabs = useScanModalTabs();
    const navigate = useNavigate();
    const { type } = useParams();

    const routeIndex = tabs.findIndex((tab) => tab.path === type);
    const [currentIndex, setCurrentIndex] = useState<number>(routeIndex);

    function onTabClick(index: number) {
        const path = generatePath(MainRoutes.SEND_AND_RECEIVE, { type: tabs[index].path });
        setCurrentIndex(index);
        navigate(path);
    }

    return (
        <BasePage>
            <YellowTabs initialIndex={routeIndex} index={currentIndex} tabs={tabs} onIndexChange={onTabClick} />
        </BasePage>
    );
}
